module.exports = "/fonts/vendor/@bcgov/bootstrap-theme/dist/bc-sans/BCSans-Regular.woff?50c6f5f1f9f7980988352b2192ec6c6d";